import { Alert, AlertProps, alertClasses, styled } from '@mui/material';

export const AlertStyled = styled((props: AlertProps) => <Alert {...props} />)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  margin: theme.spacing(2),
  [`& .${alertClasses.action}`]: { paddingTop: '2px' },
}));
